module.exports = {"transport":"http","websocket":"wss://rpc.blurt.world","uri":"https://rpc.blurt.world","url":"https://rpc.blurt.world","dev_uri":"https://test.blurt.world/rpc","stage_uri":"https://test.blurt.world/rpc","address_prefix":"BLT","chain_id":"cd8d90f29ae273abec3eaa7731e25934c63eb654d55080caff2ebb7f5df6381f","alternative_api_endpoints":["https://blurt-rpc.saboin.com","https://rpc.nerdtopia.de"],"failover_threshold":3,"useAppbaseApi":true}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 82
// module chunks = 0 1